// client/src/api/shoppingApi.js - API des listes de courses
import api from './api';

// Récupérer une liste de courses
export const getShoppingList = async (id) => {
  const response = await api.get(`/api/shopping/${id}`);
  return response.data;
};

// Mettre à jour une liste de courses
export const updateShoppingList = async (id, data) => {
  const response = await api.put(`/api/shopping/${id}`, data);
  return response.data;
};

// Marquer des éléments comme achetés
export const markItemsAsPurchased = async (id, itemIds) => {
  const response = await api.put(`/api/shopping/${id}/purchase`, { itemIds });
  return response.data;
};